export const FAQS = [
    {
        id: 0,
        category: "Donate",
        question: "How do I donate?",
        answer: "You can donate via drop off at one of our designated sites or by pickup for large items, such as fitness equipment, or large items that are not easily accessible. Contact us to learn more about our donation process."
    },
    {
        id: 1,
        category: "Donate",
        question: "What type of donations are accepted?",
        answer: "We accept food, personal care, furniture, fitness equipment, clothing donations...etc. If you have unique items that you are unsure about, please contact us and we will be happy to discuss your donation options."
    },
    {
        id: 2,
        category: "Donate",
        question: "Do you accept donations from individuals?",
        answer: "Yes, we accept donations form individuals, organizations, and businesses. We are always looking for ways to expand our reach and to help our community. If you are interested in donating to our cause, please contact us."
    },
    {
        id: 3,
        category: "Donate",
        question: "Will I receive a receipt?",
        answer: "Yes, you will receive a receipt for your donation. We will send you a copy of your receipt via email or the method you prefer."
    },
    {
        id: 4,
        category: "Donate",
        question: "Do you accept donations from non-profits?",
        answer: "Yes we accept donations from non-profits as well as donate to other charities. "
    },
    {
        id: 5,
        category: "Donate",
        question: "Is my donation tax deductible?",
        answer: "Yes, your non-profit donation is tax deductible. If you are interested in donating to our cause, please contact us."
    },
    {
        id: 6,
        category: "Donate",
        question: "Are there set hours and or days for donations?",
        answer: "Each Hero Site accepts donations during regular business hours. If you need to arrange a donation for a specific date or time, please contact us."
    },
    {
        id: 7,
        category: "Donate",
        question: "Why do you need donations?",
        answer: "Instead of purchasing new supplies and equipment for our services, we feel that repurposing and reusing existing supplies and equipment is the best way to provide a more effective and efficient service. "
    },
    {   id: 8,
        category: "Donate",
        question: "Can I donate to multiple sites?",
        answer: "Yes, you can donate to multiple sites. "
    },
    {
        id: 9,
        category: "Donate",
        question: "Do you have a list of items that you need more of?",
        answer: "Yes, we have a list of items that we need more of. If you are interested in donating to our cause, please contact us."
    },
    {
        id: 10,
        category: "Sponsor",
        question: "As a Hero Sponsor, can I use my volunteer hours to support my business?",
        answer: "No. You cannot use your volunteer hours to support your business. Volunteers are only allowed to participate in activities at your business that directly supports our mission."
    },
    {
        id: 11,
        category: "Sponsor",
        question: "How can my employer sponsor an event?",
        answer: "Your employer can sponsor an event by contacting us. We will be happy to assist you with your sponsorship needs."
    },
    {
        id: 12,
        category: "Sponsor",
        question: "I am a business owner and I want to become a Hero Sponsor. How do I do that?",
        answer: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nobis excepturi ipsam tempora aliquam. Facilis qui impedit velit fugiat veritatis quia."
    },
    {
        id: 13,
        category: "Sponsor",
        question: "Are Hero Sponsors required to use volunteers to help out?",
        answer: "Yes, we require all Hero Sponsors to use volunteers to help out. If you are interested in becoming a Hero Sponsor, please contact us."
    },
    {
        id: 14,
        category: "Sponsor",
        question: "Is there a fee to become a Hero Sponsor?",
        answer: "Hero Sponsors do not have to pay a fee to become a Hero Sponsor. "
    },
    {
        id: 15,
        category: "Sponsor",
        question: "I have a service that I would like to offer to the community. How do I do that?",
        answer: "You can contact us to discuss the service you would like to offer."
    },
    {
        id: 16,
        category: "Sponsor",
        question: "How often do Hero Sponsors meet?",
        answer: "Hero Sponsors meet every other week. We meet on the first Tuesday of the month at 6:00 PM in the Hero Sponsorship Center."
    },
    {
        id: 17,
        category: "Sponsor",
        question: "Is there a Hero Sponsor application process?",
        answer: "Yes. We have a process for Hero Sponsors to apply. "
    },
    {   id: 18,
        category: "Sponsor",
        question: "What is the Hero Sponsorship Center?",
        answer: "The Hero Sponsorship Center is located at the back of the Hero Center. We meet every other week on the first Tuesday of the month at 6:00 PM."
    },
    {
        id: 19,
        category: "Sponsor",
        question: "Can my organization sponsor a single event?",
        answer: "Yes, your organization can sponsor a single event. If you are interested in sponsoring an event, please contact us."
    },
    {
        id: 20,
        category: "Volunteer",
        question: "How do I become a volunteer?",
        answer: "You can contact us or complete the Volunteer form to get the process started. "
    },
    {
        id: 21,
        category: "Volunteer",
        question: "How old do I need to be to volunteer?",
        answer: "Our volunteers must be at least 18 years old. However, we do have special occasions, like school field trips and youth organizations, where our volunteers are under the age of 18. Contact us for more information"
    },
    {
        id: 22,
        category: "Volunteer",
        question: "How often can I volunteer?",
        answer: "We have a volunteer schedule that is flexible. You can volunteer at any time of the year, but we will need to know your availability. Contact us for more information."
    },
    {
        id: 23,
        category: "Volunteer",
        question: "As a volunteer will I be paid?",
        answer: "No, we do not pay volunteers."
    },
    {
        id: 24,
        category: "Volunteer",
        question: "Do I need to be a member of the community to volunteer?",
        answer: "We do ask that all of our volunteers be members of the community. We also have a volunteer agreement that requires all volunteers to sign it. Contact us for more information."
    },
    {
        id: 25,
        category: "Volunteer",
        question: "What hours can I volunteer?",
        answer: "Our volunteers are asked to donate 4-20hrs per week and many of our services are 24hs a week. We observe all major holidays, but there are occasions where we ask volunteers to participate on major holidays. Contact us for more information."
    },
    {
        id: 26,
        category: "Volunteer",
        question: "What is the volunteer agreement?",
        answer: "The volunteer agreement outlines the responsibilities of our volunteers and the responsibilities of the organization. We ask that all volunteers sign this agreement. Contact us for more information."
    },
    {
        id: 27,
        category: "Volunteer",
        question: "Can I volunteer for multiple events or at multiple sites?",
        answer: "Yes, as long as your participation meets the minimum requirements. Contact us for more information."
    },
    {   id: 28,
        category: "Volunteer",
        question: "I have a large group. Can we volunteer as a group?",
        answer: "Yes! Large groups are welcome to volunteer. Contact us for more information."
    },
    {
        id: 29,
        category: "Volunteer",
        question: "I am disabled. Can I volunteer?",
        answer: "Absolutely! You can discuss any special needs that you may have with a Volunteer Coordinator."
    },
    {
        id: 30,
        category: "General",
        question: "What are the hours of operation?",
        answer: "Our headquarters is open Monday through Friday, 9am to 5pm.  Please contact us for more information."
    },
    {
        id: 31,
        category: "General",
        question: "How do I contact you?",
        answer: "You can contact us by email at info@hostahealthcareheroes.org, or, call us at; 1-973-777-4321."
    },
    {
        id: 32,
        category: "General",
        question: "How do I get involved?",
        answer: "You can give us a call, contact us or visit any of our drop off sites and someone will adivise you on the volunteer process."
    },
    {
        id: 33,
        category: "General",
        question: "What's the difference between a Hero Sponsor and a Hero Volunteer?",
        answer: "A sponsor is a company that provides a service to our community free of charge.  A volunteer is a person who is willing to donate their time to serve the community."
    },
    {
        id: 34,
        category: "General",
        question: "Is this a private foundation or public charity",
        answer: "Host a Healthcare Hero is a public charity.  We are a 501(c)(3) non-profit organization."
    },
    {
        id: 35,
        category: "General",
        question: "I submitted a lot of information. Is my information secure?",
        answer: "Yes, we take your privacy very seriously.  We use a secure server to store your information.  We also use SSL to protect your information."
    },
    {
        id: 36,
        category: "General",
        question: "How is Covid-19 being handled?",
        answer: "We take the safety of our volunteers and healthcare heroes seriously.  Each volunteer and healthcare hero is required to wear a mask and follow the instructions on the mask.  We are also required to follow the CDC guidelines for handling COVID-19."
    },
    {
        id: 37,
        category: "General",
        question: "Is Host a Healthcare Hero a 501(c)(3) non-profit?",
        answer: "Yes, we are a 501(c)(3) non-profit organization."
    },
    {   id: 38,
        category: "General",
        question: "I have a question that isn't answered here. Who can I contact?",
        answer: " We're always happy to help.  Please email, call or speak to a member of our team on site."
    },
    {
        id: 39,
        category: "General",
        question: "When will the next event be?",
        answer: "We are hosting events throughout the year.  Please sign up for our newsletter or contact us to find out more."
    }
];